import * as React from "react";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { ModelPortfolioTabType } from "../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ModelPortfolio } from "../../../../../Wrap/Models/Models/Instruments/ModelPortfolio";
import { Investment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentDetailsPopupModal } from "../../../../Dashboard/Components/Clients/Common/InvestmentDetailsPopUp/InvestmentDetailsPopupModal";
import { Table } from "../../../Table/Table";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";

interface IUnderlyingTableProps {
    data: ModelPortfolio[];
    modelPortfolioType: ModelPortfolioTabType;
    isTps?: boolean;
}

export const UnderlyingTable = (props: IUnderlyingTableProps) => {
    const [isShowDetailModal, setShow] = React.useState(false);
    const [selectedInvestment, setSelected] = React.useState<Investment>(null);
    if (!props.data) {return null;}

    const renderInvestmentDetailPopupModal = (): JSX.Element => {
        if (!isShowDetailModal) {return null;}
        return (
            <>
                <InvestmentDetailsPopupModal
                    showBox={isShowDetailModal}
                    callBack={() => {
                        setShow(false);
                    }}
                    instrumentCode={selectedInvestment?.InstrumentCode}
                    productId={selectedInvestment?.ProductId}
                    instrumentName={selectedInvestment?.DisplayName}
                    unitCost={selectedInvestment?.UnitCost}
                    securityType={selectedInvestment?.Type}
                    unitPrice={selectedInvestment?.UnitPrice}
                />
            </>
        );
    };

    const onInvestmentSelected = (investment) => {
        InvestmentSelectionAction.getUnitPrice(investment, (d) => {
            setSelected(d);
            setShow(true);
        });
    };

    const col = [
        {
            title: "Underlying investments",
            key: "Name",
            render: (data, row) => {
                if (data == "GBP Cash") {return data;}
                return (
                    <a className="hyperlink" onClick={() => onInvestmentSelected(row)}>
                        {data}
                    </a>
                );
            },
        },
        {
            title: "Allocation",
            key: "Allocation",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data) => {
                return data.toFixed(2) + "%";
            },
        },
        props.modelPortfolioType == ModelPortfolioTabType.HubModel && !props.isTps
            ? {
                  title: "Tolerance",
                  key: "ToleranceRate",
                  thCssWrapper: "cell-right",
                  tdCssWrapper: "cell-right",
                  render: (data) => {
                      return data ? data.toFixed(2) + "%" : "0";
                  },
              }
            : null,
        props.modelPortfolioType == ModelPortfolioTabType.HubModel && props.isTps
            ? {
                  title: "Over Tolerance",
                  key: "ToleranceRate", //TODO: NEED CHANGE
                  render: (data) => {
                      return data.toFixed(2) + "%";
                  },
                  thCssWrapper: "cell-right",
                  tdCssWrapper: "cell-right",
              }
            : null,
        props.modelPortfolioType == ModelPortfolioTabType.HubModel && props.isTps
            ? {
                  title: "Under Tolerance",
                  key: "ToleranceRate", //TODO: NEED CHANGE
                  render: (data) => {
                      return data.toFixed(2) + "%";
                  },
                  thCssWrapper: "cell-right",
                  tdCssWrapper: "cell-right",
              }
            : null,

        ,
    ];

    return (
        <div className="te-subwrap pl-40">
            <Table col={col} data={props.data} showEmptyMsg />
            {renderInvestmentDetailPopupModal()}
        </div>
    );
};
